import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { TypeRamp } from "../../typography";
function omitStyledModalTitleProps(propName) {
  switch (propName) {
    case "type":
      return false;
    default:
      return true;
  }
}
export var StyledModalTitle = styled(TypeRamp, {
  shouldForwardProp: omitStyledModalTitleProps
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    margin: 0;\n\n    ", "\n\n    flex: 1 1 auto;\n    // To align the icon and text\n    align-items: flex-start;\n    min-width: 0; // to support eliding single-line headers\n"])), function (props) {
  return props.type === "simple" ? "\n      padding: ".concat(sizes.xLarge, "px ").concat(sizes.xSmall, "px 0px ").concat(sizes.xLarge, "px;\n      ") : "\n      padding: ".concat(sizes.xLarge, "px ").concat(sizes.xSmall, "px ").concat(sizes.large, "px ").concat(sizes.xLarge, "px;\n      ");
});
//# sourceMappingURL=Title.js.map